// https://api.myokr.ir/api/Setting/GetTenantSetting?tenantId=

// https://api.myokr.ir/api/Setting/AddTenantSetting


import axios from "axios";
import axiosInstance from "../../../Axios/Axios";

const getTenantSetting=async({queryKey}:any)=>{
    let tenantId:string|null=queryKey[1];
return axiosInstance.get(`/Setting/GetTenantSetting?tenantId=${tenantId}`)
}

const addTenantSettings=(tenantSettingData:any|null)=>{
return axiosInstance.post('/Setting/AddTenantSetting',tenantSettingData)
}

const sendPushNotification = async (subscription : any) => {
    try {
        const response = await fetch('https://localhost:485/api/Notification/SendPushNotification', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(subscription) // اطلاعات اشتراک به فرمت JSON
        });

        if (!response.ok) {
            throw new Error('Network response was not ok'); // بررسی خطاهای شبکه
        }

        const result = await response.json(); // دریافت پاسخ به صورت JSON
        console.log('Push notification sent successfully:', result); // نمایش نتیجه
    } catch (error) {
        console.error('Failed to send push notification:', error); // ثبت خطا
    }
};

export{
    getTenantSetting,
    addTenantSettings,
    sendPushNotification
}